import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/user/accessibility')({
	component: UserAccessibilityPage,
});

function UserAccessibilityPage() {
	return <div></div>;
}
